import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import languageDetector from 'i18next-browser-languagedetector';
i18next
  .use(languageDetector)
  .use(initReactI18next)
  .use(HttpApi) // Registering the back-end plugin
  .init({
    // Remove resources from here
    fallbackLng: 'en',
	backend: {
	      loadPath: '/videophone/locales/{{lng}}/{{ns}}.json'
	    },
    react: { 
        wait: true,
        useSuspense: false //   <---- this will do the magic
      },    
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
  });
export default i18next;